<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { webConfigetDefault } from '@/api/advert';

export default {
  name: 'App',
  created() {
    this.getconfig();
  },
  methods: {
    getconfig() {
      webConfigetDefault()
        .then((res) => {
          if (res.message.code == 0) {
            this.$store.dispatch('config/changeConfig', res.data);
          }
        })
        .catch(() => {
          // 后端未启动时静默处理，不显示错误
        });
    }
  }
};
</script>
